/* eslint-disable react/prop-types */
import React from 'react';

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';

function ShareButtons({
  title, url, twitterHandle, tags,
}) {
  return (
    <div style={{
      padding: '4px',
      paddingLeft: '12px',
      paddingRight: '12px',
      background: '#364552',
      borderRadius: '8px',
    }}
    >
      <p style={{ margin: '0', textAlign: 'center', fontSize: '11px' }}>
        Share
      </p>
      <FacebookShareButton url={url}>
        <FacebookIcon style={{ marginRight: 8 }} size={24} round />
      </FacebookShareButton>

      <TwitterShareButton
        url={url}
        title={title}
        via={twitterHandle}
        hashtags={tags}
      >
        <TwitterIcon style={{ marginRight: 8 }} size={24} round />
      </TwitterShareButton>

      <WhatsappShareButton url={url} title={title}>
        <WhatsappIcon size={24} round />
      </WhatsappShareButton>
    </div>
  );
}
export default ShareButtons;
